import * as Msal from 'msal';
import { UserAgentApplication } from "msal";
import store from "../store/store";
import axios from 'axios';
import AxiosConfig from "./AxiosConfig";
import qs from 'querystring-es3';
import logger from './logging';
import LogRocket from 'logrocket';
// Redux Actions
import { POPULATE_REPORTS } from "../store/Hr_Reports/types";
import { SET_LOADING, LOGIN_WITH_USERNAME_PASSWORD, LOGIN_WITH_USERNAME_PASSWORD_ERROR, UPDATE_USER_SETTINGS } from "../store/user/types";
import notificationStore from './Notifications/notificationStore';

const MSALConfig = {
    appId: 'de9409bf-af63-4a0c-aa5e-afb479f0819b',
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    // postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI,
    scopes: [
        'api://de9409bf-af63-4a0c-aa5e-afb479f0819b/user_impersonation'
    ]
};

class MsalAuth {
    userAgentApplication: UserAgentApplication; user: any; Settings: any; Token: any; LogRocketActive: boolean;
    constructor() {
        this.userAgentApplication = new Msal.UserAgentApplication({
            auth: {
                clientId: MSALConfig.appId,
                redirectUri: MSALConfig.redirectUri,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: true
            },
        });
        // this.userAgentApplication.handleRedirectCallback((error: any, response: any) => {
        //     alert("Error in msal auth->handleRedirectCallback");
        //     //console.log(error, response);
        // });
        this.user = this.userAgentApplication.getAccount();
        this.Settings = null;
        this.Token = null;
        this.LogRocketActive = false;
        if (this.user) {
            this.baseRetrieveToken();
            this.refreshToken();
        }
    }

    startLogRocketSession = (username: string, userId: string | number) => {
        userId.toString();
        LogRocket.init('vhimek/launchpoint-portal');
        LogRocket.identify(`${username} (${userId})`);
        this.LogRocketActive = true;
    }

    checkVersionNumber = () => {
        let split: any = process.env.REACT_APP_VERSION?.split(".");
        let lastVersion: any = localStorage.getItem("version")?.split(".");
        if (Number(split[0]) > Number(lastVersion[0])) {
            // show alert here
        } else if (Number(split[1]) > Number(lastVersion[1]) && Number(split[0]) > Number(lastVersion[0])) {
            // show alert here as well
        } else if (Number(split[2]) > Number(lastVersion[2])) {
            // show alert
        }
        localStorage.setItem("version", process.env.REACT_APP_VERSION || "")
    }

    ConfigValue = (test: boolean = false) => {
        this.tokenValue();
        if (test) {
            return ({
                headers: {
                    // 'content-type' : 'application/x-www-form-urlencoded',
                    'Authorization': "testing-value-from-portal(testing errors)",
                }
            })
        }
        return ({
            headers: {
                // 'content-type' : 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + this.Token,
            }
        })
    }

    SettingsValue = () => this.Settings;

    UserSettings = () => this.Settings ? this.Settings["UserSettings"] : {};

    userValue = () => {
        // //console.log("user value", this.user);
        return this.user;
    }

    updateUserSettings = (newSettings: any) => {
        // Making a full copy of settings including PortalSettings
        let copy = {
            ...this.Settings,
            UserSettings: newSettings
            // Placing new settings in UserSettings tag
        }
        this.Settings = copy;
        // Calling Redux action to update client side
        axios.post(process.env.REACT_APP_API_URL + "/api/Settings", copy, { headers: { Authorization: `bearer ${AxiosConfig.tokenValue()}` } })
            .then((response: any) => {
                // //console.log("response", response)
            })
            .catch((error: any) => {
                //console.log("error", error);
                AxiosConfig.handleError(error);
            })
        store.dispatch({ type: UPDATE_USER_SETTINGS, payload: newSettings });
    }

    tokenValue = async () => {
        let accessToken = null;
        try {
            accessToken = await this.userAgentApplication.acquireTokenSilent({
                scopes: MSALConfig.scopes
            });
        } catch (err) {
            //!!r-18-dj
            //@ts-ignore
            if (err.message !== "Token calls are blocked in hidden iframes") {
                //console.log("Token Value Error", err);
                logger.Error({
                    //!!r-18-dj
                    //@ts-ignore
                    EventMessage: "Error in login (not token call) " + err?.message,
                    EventCategory: "msalAuth",
                })
                this.logout();
            }
        }
        if (accessToken) {
            this.Token = accessToken.accessToken;
            return accessToken.accessToken;
        }
        // Will only get to this point if accessToken is still null
        // alert("Microsoft token expired");
        this.logout();
        return null;
    }

    userAgentApplicationValue = () => {
        // //console.log("Useragent value");
        return this.userAgentApplication;
    }

    clearSession = () => {
        axios.post(process.env.REACT_APP_API_URL + "/api/user/signout", {}, AxiosConfig.configValue())
            .then(response => {
                // //console.log("LOGOUT", response, response.data);
            })
            .catch(error => {
                //console.log(error);
                logger.Error({
                    EventMessage: "clearSession Error in msalAuth.ts" + JSON.stringify(error),
                    EventCategory: "msalAuth",
                });
            })
    }

    logout = () => {
        // //console.log("Calling msal logout");
        this.userAgentApplication.logout();
    }

    // login = async (callback?: VoidFunction, errorCallback?: VoidFunction) => {
    //     try {
    //         await this.userAgentApplication.loginPopup({
    //             scopes: MSALConfig.scopes,
    //             prompt: "select_account"
    //         });
    //         if (callback && errorCallback) {
    //             await this.getAccessToken(callback, errorCallback)
    //         }
    //         else if (callback) {
    //             //console.log("Calling callback now");
    //             await this.getAccessToken(callback);
    //         }
    //         else {
    //             //console.log("Getting Access Token callback");
    //             await this.getAccessToken();
    //         }
    //     }
    //     catch (err) {
    //         //!!r-18-dj
    //         //@ts-ignore
    //         if (err.message !== "Token calls are blocked in hidden iframes") {
    //             //console.log("LoginError", err);
    //             logger.Error({
    //                 //!!r-18-dj
    //                 //@ts-ignore
    //                 EventMessage: "Error in login (not token call) " + err?.message,
    //                 EventCategory: "msalAuth",
    //             })
    //             this.logout();
    //         }
    //     }
    // }

    // reauthenticate = async (successCallback?: Function, errorCallback?: Function) => {
    //     let t = await this.tokenValue();
    //     if (t) {
    //         const config = {
    //             headers: {
    //                 'content-type': 'application/x-www-form-urlencoded'
    //             }
    //         };
    //         const requestBody = {
    //             userName: "auth::" + t,
    //             password: "",
    //             grant_type: "password",
    //             client_id: process.env.REACT_APP_CLIENT_ID,
    //         }
    //         axios.post(process.env.REACT_APP_API_URL + "/token", qs.stringify(requestBody), config)
    //             .then((res: any) => {
    //                 notificationStore.unignore(res.data.userId)
    //                 permissionService.permissions = JSON.parse(res.data.roles_and_assignments)
    //                 //console.log("Base Elm Login Res", res, res.response);
    //                 let data = res.data;
    //                 let authConfig = AxiosConfig.setupConfig(data.token_type, data.access_token, data.sessionKey);
    //                 let parsedRoles: Array<string> = data.roles.split(",");
    //                 axios.get(process.env.REACT_APP_API_URL + "/api/settings", authConfig)
    //                     .then(response => {
    //                         const settings = response.data;
    //                         this.Settings = settings;
    //                         //console.log("User and Portal Settings", this.Settings);
    //                         //console.log("Portal Settings Reauthenticate", settings);
    //                         store.dispatch({
    //                             type: LOGIN_WITH_USERNAME_PASSWORD,
    //                             payload: {
    //                                 access_token: data.access_token,
    //                                 token_type: data.token_type,
    //                                 expires_in: data.expires_in,
    //                                 userName: data.userName,
    //                                 '.issued': data[".issued"],
    //                                 '.expires': data[".expires"],
    //                                 roles: parsedRoles,
    //                                 PortalSettings: settings.PortalSettings,
    //                                 UserSettings: settings.UserSettings,
    //                                 userId: data.userId,
    //                                 homeProfitCenter: data.homeProfitCenter
    //                             }
    //                         });
    //                         if (settings.UserSettings?.HrReports) {
    //                             //console.log("Found hrReports in user settings");
    //                             const hrReports = settings.UserSettings.HrReports
    //                             store.dispatch({
    //                                 type: POPULATE_REPORTS,
    //                                 payload: hrReports
    //                             })
    //                         }
    //                         if (settings.UserSettings?.Color) {
    //                             // Do something with the color
    //                             //console.log("Color was found in UserSettings Object")
    //                         }
    //                         // Notifications call
    //                         // axios.get(`${process.env.REACT_APP_API_URL}/api/User/Notifications?userId=${data.userId}&category=reference`, AxiosConfig.configValue("min"))
    //                         // axios.get(`${process.env.REACT_APP_API_URL}/api/User/Notifications?userId=${data.userId}&category=release`, AxiosConfig.configValue("min"))
    //                         // .then((response: any) => {
    //                         //     //console.log("Get notifications call");
    //                         //     //console.log(response, response.data);
    //                         // })
    //                         // .catch((error: any) => {
    //                         //     //console.log("Get notifications call error");
    //                         //     //console.log(error, error.response);
    //                         // })
    //                         // if(successCallback){
    //                         //     successCallback();
    //                         // }
    //                     })
    //                     .catch(error => {
    //                         //console.log("Error in msalAuth");
    //                         //console.log(error, error.response);
    //                         alert("Error in Msal auth 143");
    //                         store.dispatch({ type: LOGIN_WITH_USERNAME_PASSWORD_ERROR, payload: "There was a problem getting Portal and User settings." })
    //                         logger.Error({
    //                             EventMessage: "Error in reauthenticate. Couldn't get settings",
    //                             EventCategory: "msalAuth",
    //                         })
    //                         if (errorCallback) {
    //                             errorCallback();
    //                         }
    //                     })
    //             })
    //             .catch(err => {
    //                 alert("Calling Error Callback, 149")
    //                 //console.log(err, err.response);
    //                 logger.Error({
    //                     EventMessage: "Error in reauthenticate. Couldn't get token",
    //                     EventCategory: "msalAuth",
    //                 });
    //                 errorCallback && errorCallback();
    //             })
    //     } else {
    //         logger.Error({
    //             EventMessage: "Initial token value was empty in reautheticate, msalAuth.ts",
    //             EventCategory: "msalAuth",
    //         });
    //         errorCallback && errorCallback();
    //     }
    // }

    // getAccessToken = async (callback?: VoidFunction, errorCallback?: VoidFunction) => {
    //     try {
    //         let accessToken = await this.userAgentApplication.acquireTokenSilent({
    //             scopes: MSALConfig.scopes,
    //         });
    //         if (accessToken) {
    //             devLog("Access Token : " + accessToken.accessToken);
    //             const token = accessToken.accessToken;
    //             this.Token = accessToken.accessToken;
    //             store.dispatch({ type: SET_LOADING, payload: true });
    //             let data: any = {};
    //             const config = {
    //                 headers: {
    //                     'content-type': 'application/x-www-form-urlencoded'
    //                 }
    //             };
    //             const requestBody = {
    //                 userName: "auth::" + token,
    //                 password: "",
    //                 grant_type: "password",
    //                 client_id: process.env.REACT_APP_CLIENT_ID,
    //             }
    //             //console.log("Request Body", requestBody);
    //             axios.post(`${process.env.REACT_APP_API_URL}/token`, qs.stringify(requestBody), config)
    //                 .then(res => {
    //                     //console.log("Base ELM Login response -> ", res);
    //                     permissionService.permissions = JSON.parse(res.data.roles_and_assignments)
    //                     data = res.data;
    //                     let config = AxiosConfig.setupConfig(data.token_type, data.access_token, data.sessionKey);
    //                     let parsedRoles: Array<string> = data.roles.split(",");
    //                     Getting User and Portal Settings
    //                     axios.get(process.env.REACT_APP_API_URL + "/api/settings", config)
    //                         .then(response => {
    //                             const settings = response.data;
    //                             this.Settings = settings;
    //                             //console.log("User and Portal Settings", this.Settings);
    //                             //console.log("Response data from settings", settings);
    //                             store.dispatch({
    //                                 type: LOGIN_WITH_USERNAME_PASSWORD,
    //                                 payload: {
    //                                     access_token: data.access_token,
    //                                     token_type: data.token_type,
    //                                     expires_in: data.expires_in,
    //                                     userName: data.userName,
    //                                     '.issued': data[".issued"],
    //                                     '.expires': data[".expires"],
    //                                     roles: parsedRoles,
    //                                     PortalSettings: settings.PortalSettings,
    //                                     UserSettings: settings.UserSettings,
    //                                     userId: data.userId,
    //                                     homeProfitCenter: data.homeProfitCenter
    //                                 }
    //                             });
    //                             if (settings.UserSettings?.HrReports) {
    //                                 console.log("Found hrReports in user settings");
    //                                 const hrReports = settings.UserSettings.HrReports;
    //                                 store.dispatch({
    //                                     type: POPULATE_REPORTS,
    //                                     payload: hrReports
    //                                 });
    //                                 logger.Info({
    //                                     EventMessage: "Prepopulating HrReports item",
    //                                     EventCategory: "userSettings",
    //                                 })
    //                             }
    //                             Notifications call
    //                             axios.get(`${process.env.REACT_APP_API_URL}/api/User/Notifications?userId=${data.userId}&category=reference`, AxiosConfig.configValue("min"))
    //                             axios.get(`${process.env.REACT_APP_API_URL}/api/User/Notifications?userId=${data.userId}&category=release`, AxiosConfig.configValue("min"))
    //                             .then((response: any) => {
    //                                 // //console.log("Get notifications call");
    //                                 // //console.log(response, response.data);
    //                                 if(response.data){
    //                                     // Populating notifications 
    //                                     store.dispatch({ type : POPULATE_NOTIFICATIONS, payload : response.data });
    //                                     // Alerting user of new notifications
    //                                     response.data?.forEach((notification: any) => {
    //                                         if(notification.notificationState === "new"){
    //                                             store.dispatch({ type : ADD_VISIBLE_NOTIFICATION, payload : notification });
    //                                         }
    //                                     })
    //                                 }
    //                             })
    //                             .catch((error: any) => {
    //                                 //console.log("Get notifications call error");
    //                                 //console.log(error, error.response);
    //                                 AxiosConfig.handleError(error);
    //                             })
    //                             if (callback) {
    //                                 callback();
    //                             }
    //                         })
    //                         .catch(error => {
    //                             console.log("Error in msalAuth");
    //                             console.log(error, error.response);
    //                             logger.Error({
    //                                 EventMessage: "Error in get access settings. GetAccessToken msalAuth.ts",
    //                                 EventCategory: "msalAuth",
    //                             })
    //                             store.dispatch({ type: LOGIN_WITH_USERNAME_PASSWORD_ERROR, payload: "There was a problem getting Portal and User settings." })
    //                             if (errorCallback) {
    //                                 errorCallback();
    //                             }
    //                         })
    //                 })
    //                 .catch((err) => {
    //                     console.log("Login Error", err, err.response);
    //                     store.dispatch({ type: LOGIN_WITH_USERNAME_PASSWORD_ERROR, payload: "There was a problem logging you in." })
    //                     if (errorCallback) {
    //                         errorCallback();
    //                     }
    //                     logger.Error({
    //                         EventMessage: "Error in getAccessToken. Couldn't get token from portal api. Error : " + JSON.stringify(err),
    //                         EventCategory: "msalAuth",
    //                     })
    //                 })
    //             return token;
    //         } else {
    //             logger.Error({
    //                 EventMessage: "Error in getAccessToken. No initial token value msalAuth.ts",
    //                 EventCategory: "msalAuth",
    //             });
    //             console.log("No Token Returned");
    //         }
    //     }
    //     catch (err) {
    //         !!r-18-dj
    //         @ts-ignore
    //         if (err.message !== "Token calls are blocked in hidden iframes") {
    //             console.log("getAccessTokenError", err);
    //             errorCallback && errorCallback();
    //             logger.Error({
    //                 !!r-18-dj
    //                 @ts-ignore
    //                 EventMessage: "Error in getAccessToken. error with msal msalAuth.ts" + err?.message,
    //                 EventCategory: "msalAuth",
    //             });
    //             this.logout();
    //         }
    //     }
    // }

    baseRetrieveToken = async () => {
        // //console.log("Base retrieve token");
        try {
            let accessToken = await this.userAgentApplication.acquireTokenSilent({
                scopes: MSALConfig.scopes,
            });
            if (accessToken) {
                const token = accessToken.accessToken;
                this.Token = accessToken.accessToken;
                // devLog("Base setup got token" + token);
                return token;
            } else {
                logger.Error({
                    EventMessage: "Error in baseRetrieveToken. no token returned msalAuth.ts",
                    EventCategory: "msalAuth",
                });
                //console.log("No Token Returned from baseSetup");
            }
        } catch (err) {
            //!!r-18-dj
            //@ts-ignore
            if (err.message !== "Token calls are blocked in hidden iframes") {
                //console.log("baseRetrieveTokenError", err);
                logger.Error({
                    //!!r-18-dj
                    //@ts-ignore
                    EventMessage: "Error in baseRetrieveToken. error with msal msalAuth.ts" + err?.message,
                    EventCategory: "msalAuth",
                });
                this.logout();
            }
        }
    }

    refreshToken = () => {
        // This is more of a work around right now
        // Future release it will have its own redux reducer, store, etc
        if (this.user) {
            setInterval(async () => {
                try {
                    let accessToken = await this.userAgentApplication.acquireTokenSilent({
                        scopes: MSALConfig.scopes,
                    });
                    //console.log("REFRESHING MSAL TOKEN");
                    this.Token = accessToken ? accessToken.accessToken : null;
                } catch (err) {
                    //!!r-18-dj
                    //@ts-ignore
                    if (err.message !== "Token calls are blocked in hidden iframes") {
                        //console.log("refreshTokenError", err);
                        logger.Error({
                            //!!r-18-dj
                            //@ts-ignore
                            EventMessage: "Error in refreshToken. error with msal msalAuth.ts" + err?.message,
                            EventCategory: "msalAuth",
                        });
                        this.logout();
                    }
                }
            }, 1000 * 60); // Every minute the token gets a refresh
        }
    }
}
//r-18-lint-dj
//eslint-disable-next-line
export default new MsalAuth();